export default __webpack_public_path__ + "static/media/Map_Solar_Gray.c6496db5.svg";